export enum CategoryStatus {
  ARCHIVED = 'ARCHIVED',
  ACTIVE = 'ACTIVE',
}
export enum CategoryKey {
  EQUIPMENT = 'EQUIPMENT',
  ACTIVITY = 'ACTIVITY',
  // Strength / Cardio on Workouts — both tags together mean Strength &
  // Conditioning; drives the cardio vs strength statistics split.
  ACTIVITY_TYPE = 'ACTIVITY_TYPE',
  ORGANIZATION_TYPE = 'ORGANIZATION_TYPE',
  MUSCLE_GROUP = 'MUSCLE_GROUP',
  // Dynamic / Isometric / Combined on Exercises — V1 `Exercise.muscleRegime`.
  MUSCLE_REGIME = 'MUSCLE_REGIME',
  GOAL = 'GOAL',
  MOTOR_SKILL = 'MOTORS_KILL',
  SPORT = 'SPORT',
  HEALTH_ISSUE = 'HEALTH_ISSUE',
  EXPERTISE = 'EXPERTISE',
  DURATION_MIN = 'DURATION_MIN',
  DURATION_WEEK = 'DURATION_WEEK',
  GLYCEMIC_INDEX_RANGE = 'GLYCEMIC_INDEX_RANGE',
  GLYCEMIC_LOAD_RANGE = 'GLYCEMIC_LOAD_RANGE',
  MICRONUTRIENTS = 'MICRONUTRIENTS',
  GOOD_FOR = 'GOOD_FOR',
  COUNTERPRODUCTIVE_FOR = 'COUNTERPRODUCTIVE_FOR',
  DIET = 'DIET',
  MEAL_TYPE = 'MEAL_TYPE',
  PREPARATION_TIME = 'PREPARATION_TIME',
  GROCERY_TYPE = 'GROCERY_TYPE',
  MEMBERSHIP_SESSION_TYPE = 'MEMBERSHIP_SESSION_TYPE',
  MEMBERSHIP_SERVICE_TYPE = 'MEMBERSHIP_SERVICE_TYPE',
  MEMBERSHIP_PROGRAM_TYPE = 'MEMBERSHIP_PROGRAM_TYPE',
  EDUCATION_TOPIC = 'EDUCATION_TOPIC',
  DOCUMENT_MEASUREMENTS = 'DOCUMENT_MEASUREMENTS',
  DOCUMENT_ADMINISTRATIVE = 'DOCUMENT_ADMINISTRATIVE',
  DOCUMENT_TRAINING = 'DOCUMENT_TRAINING',
  DOCUMENT_HEALTH = 'DOCUMENT_HEALTH',
  DOCUMENT_MOTIVATIONAL = 'DOCUMENT_MOTIVATIONAL',
  DOCUMENT_ADDRESS = 'DOCUMENT_ADDRESS',
  DOCUMENT_NUTRITION = 'DOCUMENT_NUTRITION',
  DOCUMENT_INJURIES_REHAB = 'DOCUMENT_INJURIES_REHAB',
  DOCUMENT_CLIENT_PROGRESS = 'DOCUMENT_CLIENT_PROGRESS',
  // Nivo 4 / T13 — the two catalog categories that classify manual finance
  // entries (`FinanceEntries.categoryTagId`). `direction` on the entry and the
  // category key of its tag must agree, which is why these are two separate
  // categories rather than one with a mixed tag list.
  FINANCE_EXPENSE = 'FINANCE_EXPENSE',
  FINANCE_INCOME = 'FINANCE_INCOME',
}
export enum CategoryAppliesTo {
  EXERCISES = 'EXERCISES',
  WORKOUTS = 'WORKOUTS',
  PROGRAMS = 'PROGRAMS',
  GROCERIES = 'GROCERIES',
  MEALS = 'MEALS',
  NUTRITION_PLANS = 'NUTRITION_PLANS',
  TRAINER_EXPERTISE = 'TRAINER_EXPERTISE',
  DOCUMENT_TYPE = 'DOCUMENT_TYPE',
  MEMBERSHIPS = 'MEMBERSHIPS',
  EDUCATION = 'EDUCATION',
  ORGANIZATIONS = 'ORGANIZATIONS',
  BOOKING_EVENTS = 'BOOKING_EVENTS',
  FINANCE_ENTRIES = 'FINANCE_ENTRIES',
}
export enum CategoryGroup {
  FITNESS = 'fitness',
  NUTRITION = 'nutrition',
  PERSONAL_INFO = 'personalInfo',
  FINANCE = 'finance',
}
export const CATEGORY_GROUP_MAP: Record<CategoryGroup, CategoryAppliesTo[]> = {
  [CategoryGroup.FITNESS]: [
    CategoryAppliesTo.EXERCISES,
    CategoryAppliesTo.WORKOUTS,
    CategoryAppliesTo.PROGRAMS,
  ],
  [CategoryGroup.NUTRITION]: [
    CategoryAppliesTo.GROCERIES,
    CategoryAppliesTo.MEALS,
    CategoryAppliesTo.NUTRITION_PLANS,
  ],
  [CategoryGroup.PERSONAL_INFO]: [
    CategoryAppliesTo.TRAINER_EXPERTISE,
    CategoryAppliesTo.DOCUMENT_TYPE,
  ],
  [CategoryGroup.FINANCE]: [CategoryAppliesTo.FINANCE_ENTRIES],
};

export const isFitnessCategory = (appliesTo: CategoryAppliesTo[]) =>
  appliesTo.some((v) => CATEGORY_GROUP_MAP[CategoryGroup.FITNESS].includes(v));

export const isNutritionCategory = (appliesTo: CategoryAppliesTo[]) =>
  appliesTo.some((v) =>
    CATEGORY_GROUP_MAP[CategoryGroup.NUTRITION].includes(v),
  );
